export default function handleError(error) {
  return Promise.reject(error);
}
